module.exports = "/_next/static/files/1b63852d8c94f2eb670a429c30f093d9.mp4";